var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBbLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 989,
    height: 341,
    viewBox: "0 0 989 341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.158 254.29C153.148 254.29 129.428 244.52 112.147 217.03C122.998 251.03 142.298 265.14 182.898 270.2C223.498 275.26 256.858 270.56 261.278 262.24C265.698 253.92 227.918 205.09 227.918 205.09C235.958 245.24 239.178 254.28 196.158 254.28V254.29Z",
    fill: "url(#paint0_linear_1100_1787)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M345.66 254.29C302.65 254.29 278.929 244.52 261.649 217.03C272.499 251.03 291.8 265.14 332.4 270.2C373 275.26 406.36 270.56 410.78 262.24C415.2 253.92 377.42 205.09 377.42 205.09C385.46 245.24 388.67 254.28 345.66 254.28V254.29Z",
    fill: "url(#paint1_linear_1100_1787)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M947.402 127.96C917.742 127.96 887.092 147.57 875.622 159.29C864.152 171.01 846.162 159.29 846.162 159.29C846.162 159.29 804.241 72.77 771.811 39.62C739.381 6.47 592.26 0 494.18 0C396.1 0 248.979 6.47 216.549 39.62C184.119 72.77 142.198 159.29 142.198 159.29C142.198 159.29 124.208 171.01 112.738 159.29C101.268 147.57 70.618 127.96 40.9579 127.96C11.2978 127.96 -22.5124 160.1 20.1978 180.72C62.908 201.34 75.3681 178.9 91.9781 183.75C68.548 207.7 41.1179 210.74 34.0079 255.62C26.8878 300.5 39.3879 340.41 39.3879 340.41C39.3879 340.41 37.5579 276.68 46.4579 251.82C55.978 225.23 114.528 187.99 166.728 177.08C218.929 166.16 414.7 164.95 414.7 164.95C358.619 159.65 280.539 156.49 229.489 154.85C233.889 147.48 242.329 134.93 251.419 129.9C264.659 122.59 494.19 120.59 494.19 120.59C494.19 120.59 723.721 122.58 736.961 129.9C746.051 134.92 754.491 147.48 758.891 154.85C707.851 156.49 629.761 159.65 573.69 164.95C573.69 164.95 769.451 166.16 821.662 177.08C873.862 188 932.422 225.23 941.942 251.82C950.842 276.68 949.012 340.41 949.012 340.41C949.012 340.41 961.502 300.49 954.392 255.62C947.272 210.74 919.852 207.7 896.422 183.75C913.032 178.9 925.492 201.34 968.202 180.72C1010.91 160.1 977.102 127.96 947.442 127.96H947.402ZM793.841 153.84C776.051 137.45 752.731 113.28 736.681 113.28C719.031 113.28 494.19 107.96 494.19 107.96C494.19 107.96 269.349 113.28 251.699 113.28C235.649 113.28 212.319 137.45 194.539 153.84C183.769 153.56 177.419 153.43 177.419 153.43C187.499 100.06 220.729 54.58 258.099 37.6C295.469 20.62 494.2 12.13 494.2 12.13C494.2 12.13 692.931 20.62 730.301 37.6C767.671 54.58 800.891 100.06 810.981 153.43C810.981 153.43 804.621 153.56 793.861 153.84H793.841Z",
    fill: "url(#paint2_linear_1100_1787)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M792.212 254.29C749.202 254.29 752.412 245.25 760.452 205.1C760.452 205.1 722.662 253.93 727.092 262.25C731.512 270.57 764.882 275.27 805.472 270.21C846.072 265.15 865.362 251.04 876.222 217.04C858.942 244.53 835.222 254.3 792.212 254.3V254.29Z",
    fill: "url(#paint3_linear_1100_1787)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M642.71 254.29C599.7 254.29 602.92 245.25 610.95 205.1C610.95 205.1 573.16 253.93 577.59 262.25C582.01 270.57 615.38 275.27 655.97 270.21C696.57 265.15 715.86 251.04 726.72 217.04C709.44 244.53 685.72 254.3 642.71 254.3V254.29Z",
    fill: "url(#paint4_linear_1100_1787)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1100_1787",
    x1: 186.528,
    y1: 259.65,
    x2: 187.348,
    y2: 213.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1000E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1100_1787",
    x1: 335.97,
    y1: 262.31,
    x2: 336.8,
    y2: 215.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1000E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1100_1787",
    x1: 0.00771777,
    y1: 170.21,
    x2: 988.362,
    y2: 170.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A74B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F17A61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1100_1787",
    x1: 801.472,
    y1: 274.25,
    x2: 801.472,
    y2: 211.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1000E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1100_1787",
    x1: 651.98,
    y1: 274.25,
    x2: 651.98,
    y2: 211.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1000E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbLogo2);
export default __webpack_public_path__ + "static/media/bbLogo2.6b51e407135a0a225ee8993461d20a6b.svg";
export { ForwardRef as ReactComponent };